import { cn } from "@/libs/utils";
import { FC } from "react";

const FieldInput: FC<{
  type: 1 | 2 | 3 | 4 | 5 | 6;
  defaultValue: number;
  valueMultiple: string;
  data: { idFinanceur: number; year: number; month: number; idDevise: number };
}> = ({ type, defaultValue, valueMultiple, data }) => {
  const styleType1 = cn(
    "flex w-full items-center h-8 p-2 rounded-md border border-input pointer-events-none  bg-verdeoblue text-xs h-8 text-background focus-visible:border-verdeoblue focus-visible:text-verdeoblue",
    defaultValue == 0
      ? "bg-background text-verdeoblue border border-verdeoblue"
      : "focus-visible:text-background"
  );
  const styleType2 = cn(
    "flex w-full items-center h-8 p-2 rounded-md border border-input pointer-events-none  bg-verdeogreen text-xs h-8 text-background focus-visible:border-verdeogreen focus-visible:text-verdeogreen",
    defaultValue == 0
      ? "bg-background text-verdeogreen border border-verdeogreen"
      : "focus-visible:text-background"
  );
  const styleType3 = cn(
    "flex w-full items-center h-8 p-2 rounded-md border border-input pointer-events-none  bg-verdeoorange text-xs h-8 text-background focus-visible:border-verdeoorange focus-visible:text-verdeoorange",
    defaultValue == 0
      ? "bg-background text-verdeoorange border border-verdeoorange"
      : "focus-visible:text-background"
  );

  const styleType4 = cn(
    "flex w-full items-center h-8 p-2 rounded-md border border-input pointer-events-none  bg-[#ff0000] text-xs h-8 text-background focus-visible:border-[#ff0000] focus-visible:text-[#ff0000]",
    defaultValue == 0
      ? "bg-background text-[#ff0000] border border-[#ff0000]"
      : "focus-visible:text-background"
  );

  const styleType5 = cn(
    "flex w-full items-center h-8 p-2 rounded-md border border-input pointer-events-none  bg-[#a1560b] text-xs h-8 text-background focus-visible:border-[#a1560b] focus-visible:text-[#a1560b]",
    defaultValue == 0
      ? "bg-background text-[#a1560b] border border-[#a1560b]"
      : "focus-visible:text-background"
  );

  const styleType6 = cn(
    "flex w-full items-center h-8 p-2 rounded-md border border-input pointer-events-none  bg-[#425e1a] text-xs h-8 text-background focus-visible:border-[#425e1a] focus-visible:text-[#425e1a]",
    defaultValue == 0
      ? "bg-background text-[#425e1a] border border-[#425e1a]"
      : "focus-visible:text-background"
  );
  return (
    <div className="relative pt-1 px-1 flex-1">
      <div
        className={
          type == 1
            ? styleType1
            : type == 2
            ? styleType2
            : type == 3
            ? styleType3
            : type == 4
            ? styleType4
            : type == 5
            ? styleType5
            : styleType6
        }
      >
        {defaultValue.toLocaleString("fr-FR", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })}
      </div>
      {/* {valueMultiple != '' && <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info size={15} className="text-blue-500 absolute right-0 top-0 bg-background rounded-full"/>
            </TooltipTrigger>
            <TooltipContent>
              {valueMultiple.split('\n').map((line, index) => (
                line.includes("Total") ? <p key={index} className="mt-2"><strong>{line}</strong></p> : <p key={index} className="mb-0">{line}</p>
              ))}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>} */}
    </div>
  );
};

export default FieldInput;
